import { i18n } from '@lt/localization';
import { endsWith, includes } from 'lodash';
import * as NAMES from '../../../routes/Checkout/store/constants/names';
import { GENDER } from '../../../routes/Checkout/store/constants/tourists';

export const getGenderByName = (firstName?: string) => {
  const nameLowerCase = firstName && firstName.toLowerCase();
  if (
    includes(NAMES.MALES, nameLowerCase) ||
    includes(NAMES.MALES_RU, nameLowerCase)
  ) {
    return GENDER.MALE;
  }
  if (
    includes(NAMES.FEMALES, nameLowerCase) ||
    includes(NAMES.FEMALES_RU, nameLowerCase)
  ) {
    return GENDER.FEMALE;
  }
  return null;
};

export const getGenderByPatronymic = (patronymic?: string) => {
  const patronymicLowerCase = patronymic && patronymic.toLowerCase();
  if (
    endsWith(
      patronymicLowerCase,
      i18n.t('checkout.touristForm.patronymic.lowerCase_male'),
    )
  ) {
    return GENDER.MALE;
  }
  if (
    endsWith(
      patronymicLowerCase,
      i18n.t('checkout.touristForm.patronymic.lowerCase_female'),
    )
  ) {
    return GENDER.FEMALE;
  }
  return null;
};
